import { SuiteId } from '@fx-ui/platform-sdk';

export type IClassification = 'platform';

export interface IPlatform {
    goods?: any[];
    price?: number;
    purchase_type?: string;
    purchase_days?: number;
    product_end?: string;
    product_start?: string;
    [key: string]: any;
}

export interface ISuite {
    suite_id?: SuiteId;
    goods?: any[];
    price?: number;
    purchase_type?: string;
    purchase_days?: number;
    product_end?: string;
    product_start?: string;
    [key: string]: any;
}

export enum OrderClassification {
    OLD = 'old', // 历史订单
    PLATFORM = 'platform', // 平台订单
    APP_BUILDER = 'app_builder', // 应用搭建/简道云套件订单
    ANALYTICS = 'analytics', // 数据分析/九数云套件订单
    GOVERNANCE = 'governance', // 治理套件订单
    SALES = 'sales', // 销售套件订单
    WUFAN = 'wufan' // 悟帆套件订单
}

export interface IOrderInfos {
    category?: string;
    create_time?: string;
    creator?: string;
    expire_time?: string;
    is_cancellable?: boolean;
    is_pay_collected?: boolean;
    is_pay_proofed?: boolean;
    is_receiptable?: boolean;
    is_removable?: boolean;
    is_sub_order?: boolean;
    order_no?: string;
    ori_level?: string;
    ori_price?: number;
    pay_collect_time?: string;
    pay_meta?: any;
    pay_method?: string;
    pay_time?: string;
    price?: number;
    product_days?: number;
    product_end?: string;
    product_start?: string;
    products?: any[];
    receipt_state?: number;
    receipt_type?: string;
    state?: number;
    type?: string;
    _id: string;
    receipt_id: string;
    classification?: IClassification;
    platform?: IPlatform;
    suite?: ISuite[];
}
